import script from "./MaintainNotificationView.vue?vue&type=script&setup=true&lang=ts"
export * from "./MaintainNotificationView.vue?vue&type=script&setup=true&lang=ts"

import "./MaintainNotificationView.vue?vue&type=style&index=0&id=43df6f42&lang=css"

const __exports__ = script;

export default __exports__